<template>
  <section class="build-for-section">
    <div class="container">
      <div class="row">
        <div
          v-animation
          class="image-wrap col col-6"
          data-animation="fade-in-left"
          data-animation-mobile="fade-in-up"
        >
          <img src="@/assets/images/home/build_for_students_desktop.webp" alt="Build for section image" class="build-for-image">
        </div>
        <article
          v-animation
          class="build-for-content col col-5 offset-1"
          data-animation="fade-in-right"
          data-animation-mobile="fade-in-up"
        >
          <h2 class="build-for-title">
            Build for <strong>Students, Researchers</strong> & <strong>Data Professionals</strong>
          </h2>
          <p class="build-for-description">
            The best calculators for statistics should make your life easier—no matter your background. They’re built for clarity and accuracy, whether you’re in the classroom or on the job. If you work with data—as a student, researcher, or professional—they help you skip the manual math and focus on what the numbers mean.
          </p>
        </article>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>

<style scoped lang="scss">
.build-for-section {
  padding: 60px 0;

  .row {
    display: flex;
    align-items: center;

    .image-wrap {
      .build-for-image {
        width: 100%;
        height: auto;
        display: block;
      }
    }

    .build-for-content {
      .build-for-title {
        font-size: 36px;
        font-weight: 400;

        strong {
          text-transform: uppercase;
        }
      }

      .build-for-description {
        color: var(--main-dark-shade-2);
        font-size: 18px;
        line-height: 150%;
        margin-top: 30px;
      }
    }
  }
}

@include bp($bp-laptop-tablet) {
  .build-for-section .row .build-for-content .build-for-title {
    font-size: 32px;
  }
}

@include bp($bp-mobile) {
  .build-for-section {
    padding: 40px 0;

    .row .build-for-content {
      margin-top: 30px;

      .build-for-title {
        font-size: 28px;
      }

      .build-for-description {
        font-size: 16px;
      }
    }
  }
}
</style>
